import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full mt-8 pt-4 border-t border-gray-200 text-center">
      <p className="text-xs text-gray-500">
        <a
          href="https://www.cai.mo.it"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-800"
        >
          Club Alpino Italiano Sezione di Modena
        </a>
        <br />
        <span>Via IV Novembre 40/C</span>
        {' '}&middot;{' '}
        <span>41100 Modena (MO)</span>
        {' '}&middot;{' '}
        Tel: <a href="tel:+39059826914" className="text-blue-600 underline hover:text-blue-800">
          +39 059826914
        </a>
        {' '}&middot;{' '}
        <a href="mailto:segreteriacaimodena@gmail.com" className="text-blue-600 underline hover:text-blue-800">
          segreteriacaimodena@gmail.com
        </a>
        {' '}&middot;{' '}
        <a href="mailto:modena@cai.it" className="text-blue-600 underline hover:text-blue-800">
          modena@cai.it
        </a>
        <br />
        <Link to="/privacy" className="text-blue-600 underline hover:text-blue-800">
          Informativa sulla Privacy
        </Link>
      </p>
    </footer>
  );
}
